/**
 * @since 2017/6/6
 * @author minyu
 */

import KNB from '@dp/knb';

const getShareUrl = (appEnv) => {
    let shareUrl = window.location.href;
    if (appEnv === 'isWX') {
        const urlFilter = (url) => {
            url = url.replace(/token=((\*)|(\w*))($|&)/g, "").replace(/utm_medium=((\*)|(\w*))($|&)/g, "").replace(/version=((\*)|(\w*))($|&)/g, "").replace(/version_name=((\*)|(\w*))($|&)/g, "").replace(/utm_source=(\w*)($|&)/g, "").replace(/userid=(\w*)($|&)/g, "").replace(/msid=(\w*)($|&)/g, "").replace(/ci=(\w*)($|&)/g, "").replace(/utm_campaign=(\w*)($|&)/g, "").replace(/utm_content=(\w*)($|&)/g, "").replace(/utm_term=(\w*)($|&)/g, "");
            if (url.indexOf('?') > -1) {
                url += '&utm_source=o_weixin';
            } else {
                url += '?utm_source=o_weixin';
            }
            return url;
        };
        shareUrl = urlFilter(shareUrl);
    }
    return shareUrl;
};

export default (canShare, option = {}) => {
    const appEnv = KNB.env;
    const protocol = window.location.protocol;
    const shareUrl = getShareUrl(appEnv);

    const shareOpt = {
        title: document.title, // 分享标题
        desc: ' ', // 分享描述
        url: shareUrl, // 分享链接
        image: protocol + '//evt.dianping.com/midas/dper.jpg',
        channel: [KNB.share.WECHAT_FRIENDS, KNB.share.WECHAT_TIMELINE],
        handle: function () {
            console.log('按钮被点击了');
        },
        success: function () {
            console.log('success');
        },
        cancel: function () {
            console.log('cancel');
        },
        ...option
    };

    KNB.ready(function () {
        if (canShare) {
            KNB.configShare(shareOpt);
        } else if (appEnv === 'isWX') {
            window.wx.ready(function(){
                window.wx.hideMenuItems({
                    menuList: [
                        'menuItem:share:appMessage',
                        'menuItem:share:timeline',
                        'menuItem:share:qq',
                        'menuItem:share:weiboApp',
                        'menuItem:share:facebook',
                        'menuItem:share:QZone',
                    ]
                });
            });
        }
    });
};



// WEBPACK FOOTER //
// ./src/lib/configShare.js